<template>
  <p>
    <ion-row>
      <ion-col size="auto">
        <ion-icon
          size="large"
          :src="require('@lib/assets/icons/icon_verlaufskontrolle.svg')"
        />
      </ion-col>
      <!-- <ion-col>
                  &nbsp;<b>1.</b> Termin für Arztgespräch auswählen.</ion-col
                > -->
      <ion-col>
        &nbsp;<b>1.</b> Sie werden direkt zu Medgate weitergeleitet, damit Sie
        sich für ein Arztgespräch anmelden und einen Termin auswählen können.
      </ion-col>
    </ion-row>
  </p>
  <!-- <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="
                      require('@lib/assets/icons/icon_weiter_behandlung.svg')
                    "
                  />
                </ion-col>
                <ion-col>
                  &nbsp;<b>2.</b> Ihr Roodie.Check wird mit Ihrer Zustimmung an
                  Medgate übergeben, damit sich der passende Arzt bei Ihnen
                  meldet.
                </ion-col>
              </ion-row>
            </p> -->
  <p>
    <ion-row>
      <ion-col size="auto">
        <ion-icon
          size="large"
          :src="require('@lib/assets/icons/icon_telefon.svg')"
        />
      </ion-col>
      <ion-col>
        &nbsp;<b>2.</b> Ein/e Medgate Arzt/Ärztin kontaktiert Sie zum
        vereinbarten Termin für das persönliche Arztgespräch.
      </ion-col>
    </ion-row>
  </p>
  <p>
    <ion-row>
      <ion-col size="auto">
        <ion-icon
          size="large"
          :src="require('@lib/assets/icons/icon_erstdiagnose.svg')"
        />
      </ion-col>
      <ion-col>
        &nbsp;<b>3.</b> Am Ende erhalten Sie einen Behandlungsplan und bei
        Bedarf eine Überweisung, ein Rezept oder eine
        Arbeitsunfähigkeitsbescheinigung.
      </ion-col>
    </ion-row>
  </p>
  <p>
    <ion-row>
      <ion-col size="auto">
        <ion-icon size="large" :src="require('@lib/assets/icons/money.svg')" />
      </ion-col>
      <ion-col>
        &nbsp;<b>4.</b> ARAG erstattet die Arztrechnungen im tariflichen Rahmen
        – natürlich auch, wenn Sie einen anderen Serviceanbieter wählen.
      </ion-col>
    </ion-row>
  </p>
  <ion-icon :src="require('@lib/assets/icons/info.svg')" />
  <ion-text color="primary"
    >&nbsp;<b>Hinweis:</b>
    <p>
      Eine Fernbehandlung kann einen persönlichen Arztbesuch nicht ersetzen, ist
      aber eine sehr gute Ergänzung - gerade, wenn es um eine rasche
      Erstabklärung geht.
    </p>
  </ion-text>
</template>

<script>
import { IonRow, IonCol, IonIcon, IonText } from "@ionic/vue";

export default {
  components: {
    IonRow,
    IonCol,
    IonIcon,
    IonText,
  },
};
</script>

<style></style>
